import {RiderPayorDetailInterface} from '../../../core/interfaces/rider-payor-detail.interface';
import {ColDef, ColGroupDef} from 'ag-grid';
import Swal from 'sweetalert2';
/*const moment = require('moment');*/
import * as moment from 'moment';
export const servicesEnabled: string[] = [];
/**@description check if the service is found in the array if it doesn't include it
 * @param service
 * @param data
 */
export function verifyServiceEnabled(service: string): boolean {
  const enabled: boolean = !servicesEnabled.includes(service);
  if (enabled) {servicesEnabled.push(service); }
  return enabled;
}

/**@description check if the service is found in the array and delete service
 * @param service
 * @param data
 */
export function resetServiceEnabled(service: string): void {
  if (servicesEnabled.includes(service)) {
    setTimeout(() => {
      servicesEnabled.splice(servicesEnabled.findIndex(ser => ser === service), 1);
      }, 400
    );
  }
}

/** checkValid
 * @description retorna un string con el icono a mostrar segun chack
 * check = Valor del la columna
 */
export function checkValid(check: boolean): string {
  let icon: string;
  switch (check) {
    case true:
    {icon = `fa fa-check-circle color-success`; }
    break;
    case false:
    {icon = `fa fa-times-circle color-danger`; }
    break;
  }
  return icon;
}

/** assignNewObjet
 * @description retorna un nuevo objeto sin referencia
 * obj = objeto a copiar sin referencia.
 */
export function assignNewObjet(obj) {
  const newObj = JSON.parse(JSON.stringify(obj));
  return newObj;
}

/** assignNewArray
 * @description retorna un nuevo array sin referencia
 * @param data = array a copiar sin referencia.
 */
export function assignNewArray(data: any[]): any[] {
  const newArray = JSON.parse(JSON.stringify(data));
  return newArray;
}

/**lastStringPosition
 * @description retorna las ultimas positions de un string
 * @param details
 * @param pos cantidad de positions
 */
export function lastStringPosition(detail: string, pos: number): string {
  const val: string = detail.substring((detail.length - pos));
  return val;
}
/**validDatePlan
 * @description retorna boolean, si fecha esta dentro del rango del plan
 * @param data
 * @param date fecha
 */
export function validDatePlan(data: RiderPayorDetailInterface, date?: string): boolean {
  let valid = false;
  const dateDOS = date ? new  Date(date) : new Date();
  if (data.expirationdateformatted) {
    const start = new Date(data.startdateformatted);
    const end = new Date(data.expirationdateformatted);
    if (dateDOS >= start && dateDOS <= end ) {
      valid = true;
    }
  }
  return valid;
}
export function validDateisBefore(date1, date2): boolean {
  if (moment(date1).isValid() && moment(date2).isValid()) {
    const datestar = moment(date1);
    const dateEnd = moment(date2);
    return datestar.isSameOrBefore(dateEnd);
  } else {
    return true;
  }
}
export function calculateTimeAfter(time) {
  const dateFormate = moment().format('DD-MM-YYYY');
  const dateStar = moment(`${dateFormate} ${time}`);
  const dateEnd = moment();
  /*const duration = moment.duration(dateCom.diff(date));*/
  /*const hours = duration.asHours();*/
  return moment(dateEnd.diff(dateStar)).format('m[m] s[s]');


}
/**
 * @description retorna icon para alert de rider en grid
 */
export function iconAlert(isAlert: boolean): string {
  let alert = '';
  if (isAlert) {
    const ico = 'fa-exclamation color-danger';
    alert =  `<div style="text-align: center; width: auto"><i class="fa ${ico}" aria-hidden="true"></i></div>`;
  }
  return alert;
}

export function returnTextInArray(data: string[]): string[] {
  const html: string[] = [];
  if (data && data.length) {
    data.forEach(
      (text: string, i) => {
        html.push(`<p><b>${i + 1}).</b> ${text}</p>`);
      }
    );
  }
  return html;
}
/**
 * @description genera mensaje de las alert
 */
export function  viewMessageAlertRider(data: string[], name: string): void {
  if (data && data.length) {
    const html: string[] = returnTextInArray(data);
    Swal({
      title: name,
      html: `<div style="text-align: left">${html}</div>`,
      type: 'warning',
    });
  }
}
/**
 * @description genera columna de alertas en la grilla
 */
export function generateAlertColumn(width?: number): (ColDef | ColGroupDef) {
  return {
    headerName: `<i class="fas fa-exclamation-triangle"></i>`,
    field: 'hasrideralert',
    colId: 'hasrideralert',
    width: width ? width : 50,
    cellRenderer: (params) => {
      return iconAlert(params.data.hasrideralert);
    },
  };
}
/**
 * @description genera mensage cuando no se tiene la accion
 */
export function messagePermits(title: string): void {
  Swal({
    title: title,
    text: 'You don`t have access to perform this action.',
    type: 'info'
  });
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/export-functions/functions-services.ts